import {
  Box,
  Typography,
  Divider,
  Stack,
  Container,
  useTheme
} from "@mui/material";

import { AlertBanner } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { FcGridInfo } from "~/components/serviceSupport/FcGridInfo";
import useFlag from "~/config/flags";
import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { selectUsersFulfillmentCenter } from "~/redux/selectors/storeSelectors";

import { RecurringSchedules } from "./RecurringSchedules";

type Props = { viewTitle?: ViewNameTranslation };

export function BatchSettings({ viewTitle }: Props) {
  const { t } = useTranslation();
  const { palette } = useTheme();
  const { enableSideNavSubMenus } = useFlag();
  const userFc = useAppSelector(selectUsersFulfillmentCenter);

  useNavbar({ viewTitle });

  const panel = (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <AlertBanner severity="warning" sx={{ mb: 3 }}>
        {t("batch settings warning")}
      </AlertBanner>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h4">
            {t("batch")} {t("nav.viewname.settings")}
          </Typography>
          <FcGridInfo />
        </Stack>

        {/* General Info */}
        <Typography variant="h6">{t("overview")}</Typography>
        <Stack pl={3} gap={6} direction="row">
          <Stack direction="column" gap={3}>
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography variant="body1">
                {t("batch configuration")}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {userFc?.batchConfiguration}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={2}>
              <Typography variant="body1">{t("time zone")}</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {userFc?.timeZone}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      {/* Schedules */}
      <Divider sx={{ my: 3 }} />
      <Stack spacing={3}>
        <Typography variant="h6">{t("schedules")}</Typography>
        <Box pl={3}>
          <RecurringSchedules />
        </Box>
      </Stack>
    </Container>
  );

  return enableSideNavSubMenus ? (
    <Container>
      <Box bgcolor={palette.background.secondary} pb="4px" mt={2}>
        <Box bgcolor={palette.background.default} mx="4px" borderRadius="8px">
          {panel}
        </Box>
      </Box>
    </Container>
  ) : (
    panel
  );
}
